import { preview } from '@/components/form/preview'

import { useTexts } from './useTexts'

export function Body() {
  const texts = useTexts()
  return <preview.Value>{texts.areYouSureToReset}</preview.Value>
}
